import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class AppointmentTypeActions extends Actions{
    static get target(){
        return 'appointmentTypes'
    }
}


// WEBPACK FOOTER //
// ./actions/AppointmentTypeActions.js